// extracted by mini-css-extract-plugin
export default {"box":"ManagerLoginBtn_box__I5HN6","btn":"ManagerLoginBtn_btn__7JCNo","small":"ManagerLoginBtn_small__0O07o","text":"ManagerLoginBtn_text__Yz60F"};